import './style.scss';

import React, { useState } from 'react';
import { useDebounce } from 'react-use';

import { toEnglishLayout } from '@/shared/utils';

import { useTypedDispatch, useTypedSelector } from 'store';
import { setSearchProjectArchiveText, setSearchProjectText } from 'store/slices/ui';

import { SearchIcon } from 'assets/icons';

interface Props {
  type: 'active' | 'archive';
}

const SearchProjectField: React.FC<Props> = ({ type }) => {
  const dispatch = useTypedDispatch();
  const searchText = useTypedSelector(store =>
    type === 'active' ? store.ui.searchProjectText : store.ui.searchArchiveProjectText,
  );

  const [localText, setLocalText] = useState<string>(searchText);

  useDebounce(
    () => {
      if (type === 'active') {
        dispatch(setSearchProjectText(localText));
      }

      if (type === 'archive') {
        dispatch(setSearchProjectArchiveText(localText));
      }
    },
    200,
    [localText],
  );

  return (
    <div className="mm-search-project-field">
      <input
        value={localText}
        onInput={e => setLocalText(toEnglishLayout(e.currentTarget.value))}
        placeholder="Find project or pair"
      />
      <SearchIcon />
    </div>
  );
};

export { SearchProjectField };
